import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import './style.scss';
import { Checkbox, Input } from 'antd';
import deburr from 'lodash/deburr';
import { SearchOutlined } from '@ant-design/icons';
import { cjmEventItemSelected } from 'utils/providers/cjmHelper';

const removeVietnameseTones = (str) => str
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/đ/g, 'd')
  .replace(/Đ/g, 'D')
  .toLowerCase();
const groupByAlphabet = (array) => {
  const grouped = array.reduce((acc, item) => {
    // Chuẩn hóa toàn bộ chuỗi trước khi lấy ký tự đầu tiên
    const normalized = removeVietnameseTones(item.nameVn);
    const firstLetter = normalized.charAt(0).toUpperCase();

    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(item);
    return acc;
  }, {});

  const sortedGroups = Object.keys(grouped)
    .sort()
    .map((letter) => ({
      label: letter,
      options: grouped[letter]
        .sort((a, b) => a.nameVn.localeCompare(b.nameVn))
        .map((e) => (e)),
    }));

  return sortedGroups;
};

const FilterNational = forwardRef((props, ref) => {
  const { listCountries = [], handleScrollRoaming = () => {} } = props;
  const [tempSelectedCountries, setTempSelectedCountries] = useState(new Set());
  const [searchCountry, setSearchCountry] = useState('');
  const targetRef = useRef(null);
  const inputRef = useRef(null);
  // useEffect(() => {
  //   if (inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, []);
  useImperativeHandle(ref, () => ({
    getTempSelectedCountries: () => tempSelectedCountries,
    updateTempSelectedCountries: (data) => { setTempSelectedCountries(data); },
    resetTempSelectedCountries: () => setTempSelectedCountries(new Set()),
  }), [tempSelectedCountries]);
  
  const filteredCountries = listCountries?.filter((country) => removeVietnameseTones(country.nameVn.toLowerCase()).includes(removeVietnameseTones(searchCountry.toLowerCase())));
  
  const groupedCountries = groupByAlphabet(filteredCountries);
  
  const toggleSelection = (id) => {
    setTempSelectedCountries((prev) => {
      const newSet = new Set(prev);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);
      return newSet;
    });
  };
  
  const handleChange = (e) => {
    setSearchCountry(e.target.value);
    // handleScrollRoaming();
  };
  // const handleScrollRoaming = () => {
  //   if (targetRef?.current) {
  //     console.log(targetRef);
  //     targetRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // };
  
  // const handleChange = (checkedValues) => {
  //   // setSearchCountry(checkedValues);
  //   console.log(checkedValues);
  // };
  
  return (
    <div className="container-national">
      <div className="title-filter-national">Chọn quốc gia</div>
      <div className="wrapper-national">
          
        <Checkbox.Group
          value={[...tempSelectedCountries]}
          className="checkbox-gr-national"
          // onChange={(e) => {
          //   setTempSelectedCountries(e || []);
          // }}
        >
          {groupedCountries.length > 0 ? groupedCountries.map((group) => (
            <React.Fragment key={group.label}>
              <div className="group-title">{group.label}</div>
              {group.options.map((country) => (
                <Checkbox
                  key={country.id}
                  value={country.id}
                  onClick={()=> {
                    toggleSelection(country.id);
                    cjmEventItemSelected("myvnpt_web", "roaming_package_list", 'DS quốc gia', country.nameVn);
                  }}
                >{country.nameVn}
                </Checkbox>
              ))}
            </React.Fragment>
          )) : <div className="wrapper-national-no-data">Không tìm thấy quốc gia</div> }
        </Checkbox.Group>
        
          
      </div>
      <div className="search-filter-national">
        <div>
          <Input
            ref={inputRef}
            className="qr-code__input-custom input-country-filter"
            placeholder="Tìm kiếm Quốc gia"
            prefix={<SearchOutlined />}
            value={searchCountry}
            onChange={handleChange}
            maxLength={50}
          />
        </div>
      </div>
      <div ref={targetRef} />
    </div>
  );
  
});

export default React.memo(FilterNational);
